import React from 'react';
import ReactDOM from 'react-dom/client';
import './style.css';
import "../src/styles/actions.css";
import "../src/styles/cards.css";
import "../src/styles/common.css";
import "../src/styles/mqtt.css";
import App from "./components/App";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

// Suppress ResizeObserver loop error in development
window.addEventListener('error', e => {
  if (e.message.includes('ResizeObserver loop completed with undelivered notifications')) {
    e.stopImmediatePropagation();
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes (v5 renamed cacheTime -> gcTime)
      retry: 1,
      retryDelay: attempt => Math.min(1000 * 2 ** attempt, 30000), // Exponential backoff
      refetchOnWindowFocus: false, // Disable global refetch on focus to prevent unnecessary requests
      refetchOnReconnect: false, // Disable refetch on reconnect by default
    },
  },
});

// Make queryClient globally accessible for MQTT utilities
window.__queryClient = queryClient;

const theme = createTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
    {/*
      <div style={{ position: 'fixed', bottom: 0, right: 0, width: 400, height: '50vh', zIndex: 100000 }}>
        <ReactQueryDevtools initialIsOpen={true} />
      </div>
    */}
  </QueryClientProvider>
);